import { Navigate, useRoutes } from "react-router-dom";
import PATHS from "./paths";

import { LoginPage } from "../Templates";
import { Logout, ProtectedRoute } from "./Components";

import { AddModel, Models, Notifications, Profile, Analytics, ViewDrivers, AddDrivers, Lease, Payments, ViewVehicles, VehicleStats, AddVehicle, AddBattery, AddClient, ShowVehicles, ShowBatteries, VehicleDetail, BatteryDetail, Inventory, LeaseVehicles, PastRides, RideDetails, AddGeofence, ViewGeofences, DealersOverview, OrderDetail, OrdersOverview, InventoryOverview, InstallationVideos, ShowDealers, DealershipProfile, EditDealership, TransactionTable, Devices, SpecificDevice, MapToVehicle, ShippingDetails, ShipmentOverview, AllVehicleStats, Alerts, SetOverSpeedAlert, LiveTracking, RedirectToLogin, SetRoutes, ViewRoutes, ViewRouteStats, VehicleActivity, SubUsers, SubUsersInfo, AssignVehsToSubusers } from "../Pages";
import { Panel, Settings } from "../Templates";
import { AverageRunningReport, BatteryTemperature, BatteryVoltage, ChargeCycle, MotorTemperature, ThrottleReport, MotorStatus, HealthOfBattery } from "../Widgets";
import Tabular from "../Templates/Tabular";
import DriverStats from "../Pages/DriverStats";
import ViewClients from "../Pages/ViewClients";
import { LOGIN_REDIRECT_PATHS } from "../Library/constants";

const AnalyticsRoutes = [
  { path: PATHS.ANALYTICS,  element: <Analytics />, exact: true },
  { path: [PATHS.ANALYTICS, PATHS.MOTOR_TEMPERATURE].join("/"),                                  element: <MotorTemperature />      },
  { path: [PATHS.ANALYTICS, PATHS.MOTOR_TEMPERATURE, PATHS.REPORTS].join("/"),                   element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.MOTOR_STATUS].join("/"),                                       element: <MotorStatus />           },
  { path: [PATHS.ANALYTICS, PATHS.MOTOR_STATUS, PATHS.REPORTS].join("/"),                        element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.AVERAGE_RUNNING].join("/"),                                    element: <AverageRunningReport />  },
  { path: [PATHS.ANALYTICS, PATHS.AVERAGE_RUNNING, PATHS.REPORTS].join("/"),                     element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_TEMPERATURE].join("/"),                                element: <BatteryTemperature />    },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_TEMPERATURE, PATHS.REPORTS].join("/"),                 element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_VOLTAGE].join("/"),                                    element: <BatteryVoltage />        },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_VOLTAGE, PATHS.REPORTS].join("/"),                     element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.CHARGE_CYCLE].join("/"),                                       element: <ChargeCycle />           },
  { path: [PATHS.ANALYTICS, PATHS.CHARGE_CYCLE, PATHS.REPORTS].join("/"),                        element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_HEALTH].join("/"),                                     element: <HealthOfBattery /> },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_HEALTH, PATHS.REPORTS].join("/"),                      element: <Tabular /> },
  { path: [PATHS.ANALYTICS, PATHS.THROTTLE_PERCENT].join("/"),                                   element: <ThrottleReport />        },
  { path: [PATHS.ANALYTICS, PATHS.THROTTLE_PERCENT, PATHS.REPORTS].join("/"),                    element: <Tabular />               },

  { path: PATHS.INVENTORY,                                                                       element: <Inventory />             },
  { path: PATHS.ADDVEHICLE,                                                                      element: <AddVehicle />            },
  { path: PATHS.ADDBATTERY,                                                                      element: <AddBattery />            },
  { path: PATHS.VEHICLES,                                                                        element: <ShowVehicles />          },
  { path: PATHS.BATTERIES,                                                                       element: <ShowBatteries />         },
  { path: PATHS.BATTERY_DETAIL,                                                                  element: <BatteryDetail />         },
  { path: PATHS.VEHICLE_DETAIL,                                                                  element: <VehicleDetail />         },
  { path: PATHS.ADDMODEL,                                                                        element: <AddModel />              },
];

const LeaseRoutes = [
  { path: PATHS.LEASE,                                                                           element: <Lease />,    exact: true },
  { path: PATHS.LEASE_VEHICLES,                                                                  element: <LeaseVehicles />         },
  { path: PATHS.LEASED_VEHICLES,                                                                 element: <ViewVehicles />          },
  { path: [PATHS.LEASED_VEHICLES, PATHS.VEHICLE_STATS].join("/"),                                element: <VehicleStats />          },
  { path: [PATHS.LEASE, PATHS.DRIVERS].join("/"),                                                element: <ViewDrivers />           },
  { path: [PATHS.LEASE, PATHS.ADD_DRIVERS].join("/"),                                            element: <AddDrivers />            },
  { path: [PATHS.LEASE, PATHS.DRIVERS, PATHS.DRIVER_STATS].join("/"),                            element: <DriverStats />           },
  { path: [PATHS.LEASE, PATHS.PAYMENTS].join("/"),                                               element: <Payments />              },
  { path: [PATHS.LEASED_VEHICLES, PATHS.PAST_RIDES].join("/") + "/:vId",                         element: <PastRides />             },
  { path: [PATHS.LEASED_VEHICLES, PATHS.PAST_RIDES, PATHS.RIDE_DETAILS].join("/"),               element: <RideDetails />           },

  { path: PATHS.ADD_GEOFENCE,                                                                    element: <AddGeofence />           },
  { path: PATHS.VIEW_GEOFENCES,                                                                  element: <ViewGeofences />         },
];

const ACC_101 = [
  { path: PATHS.DEALERS_OVERVIEW,                                                                element: <DealersOverview />       },
  { path: [PATHS.DEALERS_OVERVIEW, PATHS.TRANSACTION_DETAILS].join("/"),                         element: <TransactionTable />      },
  { path: [PATHS.DEALERS_OVERVIEW, PATHS.ORDERS_OVERVIEW].join(""),                              element: <OrdersOverview />        },
  { path: [PATHS.DEALERS_OVERVIEW, PATHS.ORDERS_OVERVIEW, `/${PATHS.ORDER_DETAIL}`].join(""),    element: <OrderDetail />           },
];

const ACC_201 = [
  { path: PATHS.SHOW_DEALERS,                                                                    element: <ShowDealers />           },
  { path: PATHS.ADD_DEALER,                                                                      element: <AddClient />             },
  { path: [PATHS.SHOW_DEALERS, PATHS.SPECIFIC_DEALER].join("/"),                                 element: <DealershipProfile />     },
  { path: [PATHS.SHOW_DEALERS, PATHS.EDIT_DEALER].join("/"),                                     element: <EditDealership />        },
  { path: [PATHS.SHOW_DEALERS, PATHS.IN_STOCK].join("/"),                                        element: <Devices />               },
  { path: [PATHS.SHOW_DEALERS, PATHS.INSTALLED].join("/"),                                       element: <Devices />               },
  { path: [PATHS.SHOW_DEALERS, PATHS.SPECIFIC_DEVICE].join("/"),                                 element: <SpecificDevice />        },
  { path: [PATHS.SHOW_DEALERS, PATHS.DEVICES].join("/"),                                         element: <Devices />               },
];

const ACC_301 = [
  { path: PATHS.INVENTORY_OVERVIEW,                                                              element: <InventoryOverview />     },
  { path: [PATHS.INVENTORY_OVERVIEW, PATHS.IN_STOCK].join("/"),                                  element: <Devices />               },
  { path: [PATHS.INVENTORY_OVERVIEW, PATHS.INSTALLED].join("/"),                                 element: <Devices />               },
  { path: [PATHS.INVENTORY_OVERVIEW, PATHS.SPECIFIC_DEVICE].join("/"),                           element: <SpecificDevice />        },
  { path: [PATHS.INVENTORY_OVERVIEW, PATHS.MAP_TO_VEHICLE].join("/"),                            element: <MapToVehicle />          },
  { path: [PATHS.INVENTORY_OVERVIEW, PATHS.DEVICES].join("/"),                                   element: <Devices />               },
]

const ACC_401 = [
  { path: PATHS.SHIPMENT_OVERVIEW,                                                               element: <ShipmentOverview />      },
  { path: PATHS.ORDERS_OVERVIEW,                                                                 element: <OrdersOverview />        },
  { path: [PATHS.ORDERS_OVERVIEW, PATHS.ORDER_DETAIL].join("/"),                                 element: <OrderDetail />           },
  { path: [PATHS.SHOW_DEALERS,PATHS.OEM_DEALERS].join("/"),                                      element: <ShowDealers />           },
  { path: [PATHS.SHIPMENT_OVERVIEW, PATHS.SHIPPING_DETAILS].join("/"),                           element: <ShippingDetails />       },
  { path: [PATHS.SHIPMENT_OVERVIEW, PATHS.ORDER_DETAIL].join("/"),                               element: <OrderDetail />           },
]

const ACC_501 = [
  { path: PATHS.INSTALLATION_VIDEO,                                                              element: <InstallationVideos />    },
]

const ACC_601 = [
  { path: [PATHS.SHIPMENT_OVERVIEW, PATHS.SHIPPING_DETAILS].join("/"),                           element: <ShippingDetails />       },
  { path: [PATHS.SHIPMENT_OVERVIEW, PATHS.ORDER_DETAIL].join("/"),                               element: <OrderDetail />           },
  { path: PATHS.SHIPMENT_OVERVIEW,                                                               element: <ShipmentOverview />      },
  { path: [PATHS.SHIPMENT_OVERVIEW, PATHS.ORDERS_OVERVIEW, `/${PATHS.ORDER_DETAIL}`].join(""),   element: <OrderDetail />           },
]

const ACC_701 = [
  { path: PATHS.LIVE_TRACKING,                                                                   element: <LiveTracking />          },
  { path: [PATHS.LIVE_TRACKING, PATHS.VEHICLE_STATS].join("/"),                                  element: <VehicleStats />          },
  { path: [PATHS.LIVE_TRACKING, PATHS.PAST_RIDES].join("/") + "/:vId",                           element: <PastRides />             },
  { path: [PATHS.LIVE_TRACKING, PATHS.PAST_RIDES, PATHS.RIDE_DETAILS].join("/"),                 element: <RideDetails />           },
  { path: [PATHS.LIVE_TRACKING, PATHS.ALL_VEHICLE_STATS].join(""),                               element: <VehicleStats/>           },
]

const ACC_801 = [
  { path: PATHS.ALL_VEHICLE_STATS,                                                               element: <AllVehicleStats/>        },
  { path: [PATHS.ALL_VEHICLE_STATS, PATHS.SINGLE_VEHICLE_STATS].join("/"),                       element: <VehicleStats/>           },
]

const ACC_901 = [
  { path: PATHS.SET_ALERTS,                                                                      element: <Alerts />                },
  { path: [PATHS.SET_ALERTS, PATHS.ADD_GEOFENCE_ALERT].join("/"),                                element: <AddGeofence />           },
  { path: [PATHS.SET_ALERTS, PATHS.ADD_OVERSPEED_ALERT].join("/"),                               element: <SetOverSpeedAlert />     },
]

const ACC_1101 = [
  { path: PATHS.VEHICLE_ACTIVITY,                                                                element: <VehicleActivity />      },
]

const ACC_1201 = [
  { path: PATHS.VIEW_ROUTES,                                                                     element: <ViewRoutes />            },
  { path: [PATHS.VIEW_ROUTES, PATHS.SET_ROUTES].join(""),                                        element: <SetRoutes />             },
  { path: [PATHS.VIEW_ROUTES, PATHS.VIEW_STATS].join("/"),                                       element: <ViewRouteStats />        },
];

const ACC_1301 = [
  { path: PATHS.SUB_USERS,                                                                       element: <SubUsers /> ,            },
  { path: [PATHS.SUB_USERS, PATHS.CREATE_SUB_USER].join("/"),                                    element: <AddClient /> ,           },
  { path: [PATHS.SUB_USERS, PATHS.SUB_USER_DETS].join("/"),                                      element: <SubUsersInfo /> ,        },
  { path: [PATHS.SUB_USERS, PATHS.SUB_USER_DETS, PATHS.ASSIGN_VEHICLES].join("/"),               element: <AssignVehsToSubusers /> ,        },
];

const ACCESS_CODE_ROUTES = {
  "ACC_101": ACC_101,
  "ACC_201": ACC_201,
  "ACC_301": ACC_301,
  "ACC_401": ACC_401,
  "ACC_501": ACC_501,
  "ACC_601": ACC_601,
  "ACC_701": ACC_701,
  "ACC_801": ACC_801,
  "ACC_901": ACC_901,
  "ACC_1001": AnalyticsRoutes,
  "ACC_1101": ACC_1101,
  "ACC_1201": ACC_1201,
  "ACC_1301": ACC_1301,
}

const AppRoutes = ({ codes }) => {
  let routesArray = [];
  let baseRoutes = [];
  let settingsRoutes = [];
  let hasAccessCodes = codes && codes.length;

  if (hasAccessCodes) {
    codes.forEach(code => {
      routesArray = routesArray.concat(ACCESS_CODE_ROUTES[`ACC_${code}`]);
    });
  } else routesArray.concat([ ...AnalyticsRoutes, ...LeaseRoutes ]);

  settingsRoutes = [{ path: PATHS.PROFILE, element: <Profile /> }];
  if (!hasAccessCodes) {
    settingsRoutes.concat([{ path: PATHS.MODELS, element: <Models /> }, { path: PATHS.CLIENTS, element: <ViewClients /> }]);
  }

  baseRoutes = [
    {
      element: <ProtectedRoute />,
      children: [
        { path: "/", index: true, exact: true, element: <Navigate to={hasAccessCodes ? LOGIN_REDIRECT_PATHS[codes[0]] : PATHS.ANALYTICS} /> },
        { path: PATHS.LOGOUT, element: <Logout />, },
        { path: "/", element: <Panel codes={codes} />, children: [
            ...routesArray,
            { path: PATHS.SETTINGS, element: <Settings />, children: settingsRoutes },
            { path: PATHS.NOTIFICATIONS, element: <Notifications /> },
          ]
        },
        { path: "*", element: <RedirectToLogin />, },
      ],
    }
  ];

  const element = useRoutes(baseRoutes);

  return element;
};

export default AppRoutes;


export const UnauthorizedRoutes = () => {
  const element = useRoutes([
    { path: PATHS.LOGIN, element: <ProtectedRoute noLogin> <LoginPage /> </ProtectedRoute> },
    { path: "/", element: <Navigate to={PATHS.LOGIN} /> },
    { path: "*", element: <RedirectToLogin />, },
  ]);

  return element;
};
